import React from 'react'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

interface Props {
  standardInclusions: Array<App.PackageInclusion>
}

function CruiseStandardOnboardCreditLabel({ standardInclusions }: Props) {
  const onboardCredit = standardInclusions.find(({ parentCategory }) => parentCategory === 'ONBOARD_CREDIT')

  return <>
    {!!onboardCredit && <BodyTextBlock
      startIcon={<LineUsdCircleIcon colour="highlight-secondary" />}
      weight="bold"
      variant="medium"
      colour="highlight-secondary"
    >
      {onboardCredit.description}
    </BodyTextBlock>}
  </>
}

export default CruiseStandardOnboardCreditLabel
